import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcHelpdesk(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.25 11a8.75 8.75 0 0 1 17.5 0v4.397a6.375 6.375 0 0 1-6.375 6.353h-1.343a.75.75 0 1 1 0-1.5h1.343a4.87 4.87 0 0 0 4.072-2.193 3 3 0 0 1-.447.036h-.562a2.75 2.75 0 0 1-2.75-2.75V13a2.75 2.75 0 0 1 2.75-2.75h.563c.444 0 .863.105 1.235.292a7.25 7.25 0 0 0-14.472 0A2.74 2.74 0 0 1 6 10.25h.563A2.75 2.75 0 0 1 9.313 13v2.343a2.75 2.75 0 0 1-2.75 2.75H6a2.75 2.75 0 0 1-2.75-2.75V11m16 1.965A1.25 1.25 0 0 0 18 11.75h-.562c-.69 0-1.25.56-1.25 1.25v2.343c0 .69.56 1.25 1.25 1.25h.563c.678 0 1.23-.54 1.249-1.215zM6 11.75c-.69 0-1.25.56-1.25 1.25v2.343c0 .69.56 1.25 1.25 1.25h.563c.69 0 1.25-.56 1.25-1.25V13c0-.69-.56-1.25-1.25-1.25z",
    clipRule: "evenodd"
  }));
}
var IcHelpdesk = createNolIcon(/*#__PURE__*/forwardRef(SvgIcHelpdesk));

export { IcHelpdesk as I };
